import * as React from "react";
import type { SVGProps } from "react";
const SvgSunIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="sun_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 0a42.667 42.667 0 0 1 42.667 42.667V128a42.667 42.667 0 1 1-85.334 0V42.667A42.667 42.667 0 0 1 512 0zm362.112 149.888a42.667 42.667 0 0 1 0 60.33l-60.587 60.587a42.667 42.667 0 1 1-60.33-60.33l60.586-60.587a42.667 42.667 0 0 1 60.331 0zM341.333 512a170.667 170.667 0 1 1 341.334 0 170.667 170.667 0 0 1-341.334 0zM512 256a256 256 0 1 0 0 512 256 256 0 0 0 0-512zM0 512a42.667 42.667 0 0 1 42.667-42.667H128a42.667 42.667 0 1 1 0 85.334H42.667A42.667 42.667 0 0 1 0 512zm896-42.667a42.667 42.667 0 1 0 0 85.334h85.333a42.667 42.667 0 1 0 0-85.334H896zM270.805 753.195a42.667 42.667 0 0 1 0 60.33l-60.586 60.587a42.667 42.667 0 0 1-60.331-60.33l60.587-60.587a42.667 42.667 0 0 1 60.33 0zm482.39 0a42.667 42.667 0 0 1 60.33 0l60.587 60.586a42.667 42.667 0 0 1-60.33 60.331l-60.587-60.587a42.667 42.667 0 0 1 0-60.33zM210.219 149.888a42.667 42.667 0 0 0-60.331 60.33l60.587 60.587a42.667 42.667 0 0 0 60.33-60.33l-60.586-60.587zM554.667 896a42.667 42.667 0 1 0-85.334 0v85.333a42.667 42.667 0 1 0 85.334 0V896z"
    />
  </svg>
);
export default SvgSunIcon;
